import WorkspaceOptions from './WorkspaceOptions'
import BlogsSection from '../Sections/BlogsSection'
import FAQs from '../FAQs/FAQs'
import OfficeSearchBanner from '../common/OfficeBanner'
import OfficeSearchAndPartnerSection from '../common/OfficeSearchAndPartnerSection'
import { getFormattedCityNames, getFormattedCountryName } from '~/lib/helpers/constants'
import Container from "~/components/atoms/Container";
import Breadcrumbs from "~/components/blocks/BreadCrumbs";
import DesktopHeroBanner from "~/components/blocks/HeroBanners/HeroBannerRoundEdge";
import { Suspense } from 'react'
import { Await } from '@remix-run/react'
import WhyOfficeHub from '../Home_Page/WhyOfficeHub'

const DesktopLayout = ({ country, blogs, faqs, countryName, searchUrl, regionData }) => {
  return (
    <>
      <Container htmlFor="ultra-wide">
        <nav className="hidden md:block py-5 max-w-[70%]" aria-label="Breadcrumb">
          <Breadcrumbs params={{ country: country }} />
        </nav>
      </Container>
      <DesktopHeroBanner
        title={`Types of Offices Spaces in ${getFormattedCountryName(country)} `}
        image={`${process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES}/assets/banners/area-hero.avif`}
        html={`<p>Explore flexible workspaces across ${getFormattedCountryName(country)} with Office Hub. From ${getFormattedCityNames(country)} to business hubs, we connect you with the best coworking, serviced and private offices. Compare verified listings, view transparent pricing and book tours with ease. Our experts make finding your next office simple and free.</p>`}
        config={regionData}
      />

      <Container htmlFor="ultra-wide">
        <div>
          <div className='md:px-10'>
            <WorkspaceOptions isMobile={false} countryName={countryName} region={country} searchUrl={`${searchUrl}`} />
          </div>
          <OfficeSearchAndPartnerSection countryName={countryName} region={country} searchUrl={`${searchUrl}`} />
          <WhyOfficeHub region={country} country={country} searchUrl={`${searchUrl}`} isMobile={false} className="my-4" />

          <div className=' md:px-10 md:flex justify-between'>
            <div className='w-full'>
              {/* <MarketCoveragePieChart areaSummary={areaSummary} /> */}
            </div>
            {/* <Card className="p-4 space-y-4 shadow-md bg-white max-w-[500px] h-fit">
          <div>
            <h3 className="text-lg font-semibold mb-2">Looking for {areaSummary?.spaceTypeFormula} in {areaSummary?.suburb}?</h3>
            <p className="text-sm text-oh-black">
              Explore average desk pricing, popular suburbs, and local workspace trends for office spaces across {areaSummary?.suburb}.
            </p>
            <a href="#" className="text-red-500 text-sm font-medium mt-2 inline-block">
              See {areaSummary?.suburb} {areaSummary?.spaceTypeFormula} Overview
            </a>
          </div>

          <Separator />

          <div className=''>
            <h3 className="text-lg font-semibold mb-2">Average Desk Price in {areaSummary?.suburb}</h3>
            <div className="text-sm">
              <div className="grid grid-cols-3 mb-2 font-semibold">
                <div>SIZE</div>
                <div>AVERAGE RATE</div>
                <div>LISTINGS</div>
              </div>

              {areaSummary?.areaProfileSummary.map((item, index) => (
                <div key={index} className="grid grid-cols-3 py-2 text-start pl-2 even:bg-gray-100 rounded">
                  <div>{item.name}</div>
                  <div>{item.deskMonthlyPrice}</div>
                  <div>{item.totalListings}</div>  
                </div>
              ))}
            </div>

            <a href="#" className="text-red-500 text-sm font-medium mt-2 inline-block">
              See All {areaSummary?.spaceTypeFormula} Listings in {areaSummary?.suburb}
            </a>
          </div>
        </Card> */}
          </div>
          <Suspense fallback={null}>
            <Await resolve={blogs}>
              {(blogs) => {
                return (
                  <div className='px-10'>
                    <BlogsSection areaBlogs={blogs.blogs} description={`Explore trends, data, and tips shaping ${getFormattedCountryName(country)}’s dynamic office market`} />
                  </div>
                )
              }}
            </Await>
          </Suspense>

          {/* <GoogleReviews country={getFormattedCountryName(country)} isMobile={false} /> */}

          <Suspense fallback={null}>
            <Await resolve={faqs}>
              {(faqs) => {
                return (
                  <div className='md:px-10'>
                    <FAQs title={`Answers to Common Workspace Queries in ${getFormattedCountryName(country)}`} faqs={faqs} />
                  </div>
                )
              }}
            </Await>
          </Suspense>


        </div>
      </Container>
      <OfficeSearchBanner country={country} />
    </>
  )
}

export default DesktopLayout